import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CommonTranslationModule, CommonUIElementsModule } from '@sdbn/common';
import { DictionaryModule } from '@sdbn/appclient';
import { MaterialModule } from '@sdbn/appclient';
import { PersonalVisitListComponent } from './component/personal-visit-list.component';
import { CommonLayoutModule } from '@sdbn/common';

@NgModule({
  declarations: [
    PersonalVisitListComponent
  ],
  imports: [
    CommonModule,
    DictionaryModule,
    MaterialModule,
    CommonTranslationModule,
    CommonLayoutModule,
    CommonUIElementsModule
  ],
  exports: [
    PersonalVisitListComponent
  ]
})
export class PersonalVisitListModule { }
